// extracted by mini-css-extract-plugin
module.exports = {"title":"Screen_title__1cbro","title-bar":"Screen_title-bar__pW7hV","link":"Screen_link__mRo-M","disabled":"Screen_disabled__JVknz"};